import React from 'react'

import { useTranslation } from 'react-i18next'

import { Flex, HStack, Stack, Text } from '@enechain/ecloud-designsystem'
import { StatusBadge } from '@enechain/eposition-ui'

import { ResultFeeTable } from '~/pages/Simulation/components/SimulationAndResultArea/AvailableDealSimulationSection/ResultSection/ResultFeeTable'
import { ResultAvailableDealSimulationForOption1Table } from '~/pages/Simulation/components/SimulationAndResultArea/AvailableDealSimulationSection/ResultSection/ResultForOption1/ResultAvailableDealSimulationForOption1Table'
import { ResultLatestPositionForOption1Table } from '~/pages/Simulation/components/SimulationAndResultArea/AvailableDealSimulationSection/ResultSection/ResultForOption1/ResultLatestPositionForOption1Table'
import { ResultAvailableDealSimulationForOption2Table } from '~/pages/Simulation/components/SimulationAndResultArea/AvailableDealSimulationSection/ResultSection/ResultForOption2/ResultAvailableDealSimulationForOption2Table'
import { ResultLatestPositionForOption2Table } from '~/pages/Simulation/components/SimulationAndResultArea/AvailableDealSimulationSection/ResultSection/ResultForOption2/ResultLatestPositionForOption2Table'
import { FeeResultModel } from '~/pages/Simulation/models/SimulationResultModel/FeeResultModel'
import {
  ResultAvailableDealSimulationDetailResult,
  isOption1Result,
  isOption2Result,
} from '~/pages/Simulation/models/SimulationResultModel/ResultAvailableDealSimulationDetailResult'

type Props = {
  resultDetail: ResultAvailableDealSimulationDetailResult
  feeResults: FeeResultModel[] | undefined
}

export const ResultAvailableDealSimulation: React.FC<Props> = ({
  resultDetail,
  feeResults,
}) => {
  const { t } = useTranslation(['page'])

  if (resultDetail === undefined) {
    return null
  }

  return (
    <Stack gap="4">
      <Flex justifyContent="space-between" alignItems="center">
        <Stack gap="1">
          <Text textStyle="headerXs">
            {t('page:simulation.simulation_result')}
          </Text>
          <Text textStyle="textSm" color="Text.midEmphasis">
            {t('page:simulation.available_deal_simulation_description')}
          </Text>
        </Stack>
        <HStack gap="2" alignItems="center">
          <Text textStyle="textLabel" color="Text.lowEmphasis">
            {t('page:simulation.available_deal_title')}:
          </Text>
          <StatusBadge value={resultDetail.allowDealStatus} />
        </HStack>
      </Flex>
      <Stack gap="2">
        <Text textStyle="headerSm">
          {t('page:simulation.fee_simulation_result')}
        </Text>
        <ResultFeeTable feeResults={feeResults} />
      </Stack>
      <Stack gap="2">
        <Text textStyle="headerSm">
          {t('page:simulation.simulation_result_detail')}
        </Text>
        <Stack gap="4">
          {isOption1Result(resultDetail) && (
            <>
              <ResultLatestPositionForOption1Table
                resultDetail={resultDetail}
              />
              <ResultAvailableDealSimulationForOption1Table
                resultDetail={resultDetail}
              />
            </>
          )}
          {isOption2Result(resultDetail) && (
            <>
              <ResultLatestPositionForOption2Table
                resultDetail={resultDetail}
              />
              <ResultAvailableDealSimulationForOption2Table
                resultDetail={resultDetail}
              />
            </>
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}
